<template>
	<div>
		<comp-loading/>
		<comp-sidebar/>
		<comp-header/>
		<comp-sidebar-extra />
		<v-content class="back-header bodytext--text">
			<v-container
				:class="[`grid-list-${viewList.rowing ? 'xs' : 'lg'}`]"
				pt-0
				pb-5
				mx-auto
				class="campos"
			>
				<router-view :key="$route.fullPath"/>
				<comp-snackbar
					v-if="snackbar.active"
					:x="snackbar.x"
					:y="snackbar.y"
					:timeout="snackbar.timeout"
				/>
				<comp-confirm-dialog v-if="dialog.dialogOpen" />

			</v-container>
		</v-content>
		
	</div>
</template>

<script>
import compHeader from './Header'

import compSidebar from './Sidebar'
import compSidebarExtra from './SibebarExtra'
import compSnackbar from '../components/Snackbar/Snackbar'
import compConfirmDialog from '../components/Dialog/ConfirmDialog'
import compLoading from '../components/Loading/Loading'
import { staticSetup } from '../config'

import { mapState } from 'vuex'

export default {
	components: {
		compLoading,
		compHeader,
		compSidebar,
		compSidebarExtra,
		compSnackbar,
		compConfirmDialog
	},
	data() {
		return {
			staticSetup
		}
	},
	computed: {
		...mapState('listItems', ['viewList']),
		...mapState(['snackbar', 'toolbar', 'dialog', 'extraSidebar'])
	}
}
</script>

<style lang="scss">
.back-header {
	position: relative;
}
.campos {
	min-height: calc(75vh - 75px);
}
</style>
